import React from "react";
import "./../topBar/topBar.css";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { NavStyle, LinkStyle } from "./../localStyles/localStyles";
import UserMenu from "./../userMenu/userMenu";
import Api from "../../services/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons'
export default class TopBar extends React.Component {
  state = {
    machines: false,
    productionOrders: false,
    departments: false,
    factory: true,
    reasons: true,
    work_shift: true,
    employees: false,
    items: false,
  };

  async componentDidMount() {
    await Api.get("/factorys")
      .then((response) => {
        if (response.data.length > 0) this.setState({ departments: true });
      })
      .catch((error) => {

      });
    await Api.get("/work-shifts")
      .then((resp) => {
        if (resp.data.length > 0) {
          this.setState({ employees: true });

          Api.get("/departments")
            .then((res) => {
              if (res.data.length > 0) this.setState({ machines: true });
            })
            .catch((error) => { });
        }
      })
      .catch((error) => {
      });
    await Api.get("/machines")
      .then((respo) => {
        if (respo.data.length > 0) {
          this.setState({
            items: true
          });
        }
      })
      .catch((error) => { });
    await Api.get("/items")
      .then((respo_data) => {
        if (respo_data.data.length > 0) {
          this.setState({
            productionOrders: true
          });
        }
      })
      .catch((error) => { });
  }

  render() {
    const {
      machines,
      productionOrders,
      departments,
      reasons,
      factory,
      work_shift,
      employees,
      items,
    } = this.state;

    return (
      //<header className="top_data">
      <Navbar collapseOnSelect style={NavStyle} expand="lg" variant="dark">
        <Navbar.Brand>
          <Link style={LinkStyle} to="/dashboard">
            AlliaMES Home
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto" style={{marginRight: 'auto'}}>
            <NavDropdown title="Cadastros">
              {factory ? (
                <NavDropdown.Item id="item1" href="#/plantas">
                  Plantas
                </NavDropdown.Item>
              ) : (
                <NavDropdown.Item id="item1" href="#/setores" disabled>
                  Plantas
                </NavDropdown.Item>
              )}
              {work_shift ? (
                <NavDropdown.Item id="item2" href="#/turnos">
                  Turnos
                </NavDropdown.Item>
              ) : (
                <NavDropdown.Item id="item2" href="#/turnos" disabled>
                  Turnos
                </NavDropdown.Item>
              )}

              {departments ? (
                <NavDropdown.Item id="item3" href="#/setores">
                  Setores
                </NavDropdown.Item>
              ) : (
                <NavDropdown.Item id="item3" href="#/setores" disabled>
                  Setores
                </NavDropdown.Item>
              )}
              {machines ? (
                <NavDropdown.Item id="item4" href="#/maquinas">
                  Máquinas
                </NavDropdown.Item>
              ) : (
                <NavDropdown.Item id="item4" href="#/maquinas" disabled>
                  Máquinas
                </NavDropdown.Item>
              )}
              {reasons ? (
                <NavDropdown.Item id="item5" href="#/motivos">
                  Motivos
                </NavDropdown.Item>
              ) : (
                <NavDropdown.Item id="item5" href="#/motivos" disabled>
                  Motivos
                </NavDropdown.Item>
              )}
              {employees ? (
                <NavDropdown.Item id="item6" href="#/funcionarios">
                  Funcionários
                </NavDropdown.Item>
              ) : (
                <NavDropdown.Item id="item6" href="#/funcionarios" disabled>
                  Funcionários
                </NavDropdown.Item>
              )}
              {productionOrders ? (
                <NavDropdown.Item id="item7" href="#/ordens">
                  Ordens
                </NavDropdown.Item>
              ) : (
                <NavDropdown.Item id="item7" href="#/ordens" disabled>
                  Ordens
                </NavDropdown.Item>
              )}
              {items ? (
                <NavDropdown.Item id="item8" href="#/itens">
                  Itens
                </NavDropdown.Item>
              ) : (
                <NavDropdown.Item id="item8" href="#/itens" disabled>
                  Itens
                </NavDropdown.Item>
              )}
              {true ? (
                <NavDropdown.Item id="item9" href="#/apontamentos">
                  Apontamentos
                </NavDropdown.Item>
              ) : (
                <NavDropdown.Item id="item9" href="#/apontamentos" disabled>
                  Apontamentos
                </NavDropdown.Item>
              )}
            </NavDropdown>
            <NavDropdown title="Gráficos">
              <NavDropdown.Item id="item10" href="#/dashboard">
                Dashboard de Máquinas
              </NavDropdown.Item>
              <NavDropdown.Item id="item10" href="#/dashboardTV">
                Dashboard de Máquinas TV
              </NavDropdown.Item>
              <NavDropdown.Item id="item11" href="#/dashboard-stops">
                Dashboard de Paradas
              </NavDropdown.Item>
              {/* <NavDropdown.Item id="item12" target="_blank" rel="noopener noreferrer" href="https://app.powerbi.com/reportEmbed?reportId=c54a2d6b-626b-4ae6-88cb-ff7eef4e8e55&autoAuth=true&ctid=87cf8b7d-27e4-4b0b-a256-8a921ccf7b64">
                    Power BI OEE dash 
                  </NavDropdown.Item>  */}
            </NavDropdown>
            <Nav.Link href="#/relatorios/">Relatórios</Nav.Link>
            <Nav.Link href="#/parametros/">Parâmetros</Nav.Link>
          </Nav>
          <Nav id="user">
            <FontAwesomeIcon icon={faUser} color="#868f8c" />
            <UserMenu username={this.props.username}></UserMenu>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      // </header>
    );
  }
}